import { createContext, useContext } from 'react';
import { DEFAULT_LAYOUT_CONTEXT_VALUE } from './LayoutContext.defaults';
import type { LayoutContextType } from './LayoutContext.types';

export type { LayoutContextType } from './LayoutContext.types';
export type { FirmBaseLayoutLegacyContextValue } from './LayoutContext.types';

const LayoutContext = createContext<LayoutContextType>(DEFAULT_LAYOUT_CONTEXT_VALUE);

LayoutContext.displayName = 'LayoutContext';

export const useLayoutContext = (): LayoutContextType => useContext(LayoutContext);

export default LayoutContext;
